import React, { useState } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  checkboxStyle: {
    cursor: 'pointer',
    padding: '0px 5px',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}47`,
      borderRadius: '3px'
    }
  },
  root: {
    padding: '5px 0px'
  },
  textColor: {
    color: theme.palette.primary.main
  }
}));

const CheckboxButton = ({
  title,
  checked,
  hasTransparentBg,
  onChange,
  name,
  onTermsChange,
  ...rest
}) => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(checked);

  const handleCheckboxClick = () => {
    if (onChange) {
      onChange({ name, value: !isChecked });
    }
    if (onTermsChange && !isChecked) {
      onTermsChange();
    }
    setIsChecked(prevState => !prevState);
  };

  return (
    <Box
      bgcolor={hasTransparentBg ? 'transparent' : '#FFF'}
      width="100%"
      display="flex"
      alignItems="center"
      onClick={handleCheckboxClick}
      className={classes.checkboxStyle}
    >
      <Checkbox
        checked={isChecked}
        value={isChecked}
        color="primary"
        classes={{ root: classes.root }}
        name={name}
        {...rest}
      />
      <Typography
        variant="subtitle1"
        component="p"
        color={isChecked ? 'primary' : 'textPrimary'}
      >
        {title}
      </Typography>
    </Box>
  );
};

CheckboxButton.propTypes = {
  title: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  hasTransparentBg: PropTypes.bool,
  onChange: PropTypes.func,
  onTermsChange: PropTypes.func,
  name: PropTypes.string
};

CheckboxButton.defaultProps = {
  hasTransparentBg: false,
  onChange: null,
  onTermsChange: null,
  name: null
};

export default CheckboxButton;
